// eslint-disable-next-line id-match
import { PUBLIC_ROUTES } from 'constants/general';

import { Route, RouteComponentProps } from 'react-router-dom';
import { StaticContext } from 'react-router';

import UnregisteredAccount from '../pages/auth/UnregisteredAccount';
import InvalidNameID from '../pages/auth/InvalidNameID';
import CheckInbox from '../pages/auth/CheckInbox';
import ConfirmForgotPassword from '../pages/auth/ConfirmForgotPassword';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ExternalFeedbackResponseComposer from '../pages/feedback-v2/respond/ExternalFeedbackResponseComposer';
import ExternalKakapoFeedbackRedirect from '../pages/feedback-v2/respond/ExternalKakapoFeedbackRedirect';
import LearningCertificateRender from '../pages/learning/pages/LearningCertificateRender';
import SSO from '../pages/auth/SSO';
import EngagementResponse from 'engagement/EngagementResponse';

export type RouteComponentPropsWithRedirectUrl = RouteComponentProps<
	{},
	StaticContext,
	{ originalTargetUrl?: string }
>;

const publicRoutes = [
	<Route exact key={PUBLIC_ROUTES.SSO} path={PUBLIC_ROUTES.SSO}>
		<SSO />
	</Route>,
	<Route exact key={PUBLIC_ROUTES.FORGOT_PASSWORD} path={PUBLIC_ROUTES.FORGOT_PASSWORD}>
		<ForgotPassword />
	</Route>,
	<Route exact key={PUBLIC_ROUTES.FORGOT_PASSWORD} path={PUBLIC_ROUTES.CONFIRM_FORGOT_PASSWORD}>
		<ConfirmForgotPassword />
	</Route>,
	<Route exact key={PUBLIC_ROUTES.UNREGISTERED_ACCOUNT} path={PUBLIC_ROUTES.UNREGISTERED_ACCOUNT}>
		<UnregisteredAccount />
	</Route>,
	<Route exact key={PUBLIC_ROUTES.INVALID_NAMEID} path={PUBLIC_ROUTES.INVALID_NAMEID}>
		<InvalidNameID />
	</Route>,
	<Route exact key={PUBLIC_ROUTES.CHECK_INBOX} path={PUBLIC_ROUTES.CHECK_INBOX}>
		<CheckInbox />
	</Route>,
	<Route key={PUBLIC_ROUTES.EXTERNAL_KAKAPO_FEEDBACK} path="/external/feedback/respond/:secret">
		{({ match }) => (
			<ExternalKakapoFeedbackRedirect secret={decodeURIComponent(match!.params.secret)} />
		)}
	</Route>,
	<Route
		key={PUBLIC_ROUTES.EXTERNAL_FEEDBACK}
		path={[
			'/external-feedback/:id/respond/:secret',
			'/v2/feedback/external/:id/respond/:secret',
			'/feedback/external/:id/respond/:secret',
		]}
	>
		{({ match }) => (
			<ExternalFeedbackResponseComposer
				responseID={match!.params.id}
				secret={match!.params.secret}
			/>
		)}
	</Route>,
	<Route key="/exports/learning/certificates/:id" path="/exports/learning/certificates/:id">
		{({ match }) => <LearningCertificateRender certificateID={match!.params.id} />}
	</Route>,
	<Route key="/v2/engagement/:id" path={['/v2/engagement/:id', '/engagement/:id']}>
		{({ match, location }) => (
			<EngagementResponse
				id={match!.params.id}
				secret={new URLSearchParams(location.search).get('secret') ?? undefined}
			/>
		)}
	</Route>,
];
export default publicRoutes;
